/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    code?: boolean;
    companyId?: boolean;
    areaId?: boolean;
    typeId?: boolean;
    sequence?: boolean;
    sequenceManual?: boolean;
    name?: boolean;
    description?: boolean;
    keywords?: boolean;
    ownerUserId?: boolean;
    status?: boolean;
    restricted?: boolean;
    allowDownload?: boolean;
    passwordHash?: boolean;
    currentVersionId?: boolean;
}

